module.exports = __webpack_public_path__ + "img/lifecoach2.77e89e45.jpg";